import DemoMonarchSpecRouteScreen from "../../../../src/features/arrangements/screens/DemoMonarchSpecRouteScreen";

export default function DemoMonarchMemorialPreviewRoute() {
  return <DemoMonarchSpecRouteScreen fixedPath="memorial-preview/:caseId" />;
}
